// TODO: import/export from subfile
export interface OffsetPagedResults<T extends object> {
	hasMore: boolean;
	page: number;
	pageSize: number;
	total: number;
	results: T[];
}

export function getEmptyOffsetPagedResults<T extends object>(
	page: number = 0,
	pageSize: number = 0
) {
	return {
		hasMore: false,
		page: page,
		pageSize: pageSize,
		total: 0,
		results: [] as T[],
	} as OffsetPagedResults<T>;
}

export interface Period {
	start: Date;
	end: Date;
}

export interface GeoCoordinate {
	latitude: number;
	longitude: number;
	// TODO: not used, but should we?
	height?: number;
}

export interface IdReference {
	id: string;
}

export interface BaseReference extends IdReference {
	name: string;
}

export {
	connectivityProfiles,
	ConnectivityProfileEnum,
	ConnectivityProfileFrequencyEnum,
	getConnectivityProfile,
} from './connectivityProfile';
